export enum ToastrTypesEnums {
    SUCCESS = "success",
    DANGER = "danger",
}
